import { call, put, takeEvery } from 'redux-saga/effects';
import { getSlateDataFailure, getSlateDataSuccess } from '../actions/slateDataActions';
import { GET_SLATE_DATA_REQUEST } from '../../../../constants/ActionNameConstants';
import { postApiRequest } from '../../../../features/axiosClient';
import { VENDOR_TRANSCRIPT_SUBMIT_URL_COPY } from '../../../../constants/ApiUrlConstants';
import toast from 'react-hot-toast';
import { getAllSpeakersRequest } from '../../Editor/actions';

// const getSlateDataApi = (action) => postApiRequest(`${VENDOR_TRANSCRIPT_SUBMIT_URL_COPY}?audioFileId=${action}`);
const getSlateDataApi = (action) =>
  postApiRequest(`${VENDOR_TRANSCRIPT_SUBMIT_URL_COPY}`, {
    isClickOnClaim: action.isClickOnClaim || false,
    isRestore: false,
    fileStatus: action.status || '',
    audioFileId: action.id,
  });
function* fetchSlateDataSaga(action) {
  try {
    const response = yield call(getSlateDataApi, action.payload);
    if (response?.data?.errorMessage !== '' && !response.data?.success) {
      toast.error(response?.data?.errorMessage);
    }
    const jsonResponse = JSON.parse(response.data.value);
    yield put(getSlateDataSuccess(jsonResponse.JsonTranscript));
    yield put(getAllSpeakersRequest(action.payload.id));
    
  } catch (error) {
    yield put(getSlateDataFailure(error.message));
  }
}

export function* watchFetchSlateData() {
  yield takeEvery(GET_SLATE_DATA_REQUEST, fetchSlateDataSaga);
}
